export default __webpack_public_path__ + "static/media/Split City Teleport.c23946b0.PNG";